var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time-picker',{class:_vm.classes,attrs:{"steps":[1, 1, 5],"value":_vm.current_value,"format":"mm:ss"},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }